import { apiRequest } from "./queryClient";

export async function workflowJson<T>(method: string, path: string, body?: unknown): Promise<T> {
  return (await apiRequest(method, path, body)).json();
}

export function workflowError(error: unknown): string {
  const raw = error instanceof Error ? error.message.replace(/^\d+:\s*/, "") : "Não foi possível concluir a operação.";
  try {
    const parsed = JSON.parse(raw);
    const fields = parsed.errors?.fieldErrors as Record<string,string[]> | undefined;
    const details = fields ? Object.values(fields).flat().join(" ") : "";
    return details ? `${parsed.message ?? "Confira os campos informados."} ${details}` : parsed.message ?? raw;
  } catch { return raw; }
}

export async function downloadDelivery(id: string): Promise<void> {
  const response = await apiRequest("GET", `/api/remonta/ordens-servico/${id}/entrega.pdf`);
  const url = URL.createObjectURL(await response.blob());
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = `entrega-${id.slice(0, 8)}.pdf`;
  anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
